import React from "react";
import { usePrivacyStyles } from "./Privacy.styles";

export const PrivacyEn: React.FC = () => {
  const classes = usePrivacyStyles();

  return (
    <div className={classes.root} dir="ltr">
      <h1 className={classes.mainHeader}>Privacy Policy</h1>
      <div className={classes.subMainHeader}>
        Last updated: December 12, 2024
      </div>

      <ol className={classes.list}>
        <li className={classes.content}>
          The Operator of the Website respects your privacy and the privacy of
          its users. The purpose of the terms set out in this Privacy Policy,
          which constitute an integral part of the Website’s Terms of Use, is to
          explain how the Website Operator and/or the Company use information
          provided by you on the Website and/or collected during your use of the
          Website, and to detail the Company’s policy for protecting users’
          privacy in accordance with applicable law.
        </li>

        <li className={classes.content}>
          The Website Operator and/or the Company may amend their Privacy Policy
          from time to time to reflect technological, business, legal, or
          regulatory changes. In such cases, the updated policy will be
          published on the Website. Your use of the Website after such changes
          constitutes your consent, and therefore we recommend reviewing this
          policy periodically.
        </li>

        <li className={classes.content}>
          By entering, accessing, and using the Website and/or its services, the
          user expresses consent to the collection, processing, and storage of
          information in the databases of the Website Operator, the Company, and
          the database owner, whose contact details appear in this Privacy
          Policy.
        </li>

        <li className={classes.content}>
          The user agrees and declares that all information provided to the
          Company is given voluntarily and with consent, for the purpose of
          receiving the services and in accordance with the purposes described
          in this Privacy Policy. It is clarified that without such consent, the
          Company may be unable to provide some or all services. If you do not
          agree to this Privacy Policy, you are not authorized to use the
          Website and/or its services.
        </li>

        <li className={classes.content}>
          <b>Transfer of Information to the Company</b> – The Website Operator
          and/or the Company maintain a database in which your details are
          stored, as described in this Privacy Policy. Among its purposes is to
          update the user regarding promotions and/or services offered by the
          Company, its representatives, and/or third parties with whom the
          Operator and/or the Company have business cooperation.
        </li>

        <li className={classes.content}>
          The user declares and undertakes that all information submitted or
          updated on the Website is correct, reliable, and accurate, and that it
          is provided solely on his own behalf and not on behalf of any third
          party unless expressly permitted. Information provided by the user, as
          well as additional information accumulated about him and his actions
          on the Website, will be stored in the Company’s database and used in
          accordance with the purposes described in this policy and/or as
          required by law.
        </li>

        <li className={classes.content}>
          <b>Collection and Use of Information</b> – The Website Operator and/or
          the Company may collect and use information provided by the user
          during registration, when contacting the Company and/or the Website
          Operator, and information accumulated about the user during use of the
          Website, including the following:
          <b>technical information and digital identifiers</b> such as browser
          type, device details, IP address, browsing data, and usage habits.
          This information may be collected through Cookies and other tracking
          files as described below;
          <b>
            registration for the Website and/or services and purchasing through
            the Website
          </b>{" "}
          – when registering and purchasing products, the Operator and/or
          Company may collect personal data required to provide services,
          including full name, phone number, address, and email. Additional
          information may be requested as needed;
          <b>contacting the Company</b> – information the user voluntarily
          provides when contacting the Company via the “Contact Us” form,
          including name, email address, and any other details.
        </li>

        <li className={classes.content}>
          <b>Purpose of Collection</b> – The Website Operator and/or the Company
          may use the information collected about you in order to: (a) improve,
          enhance, or modify (including tailoring the Website to the user) the
          Website, services, and content; (b) update the user regarding
          promotions and/or services offered by the Company, its
          representatives, or business partners; (c) secure the information on
          the Website, including preventing fraud, operational issues, security
          breaches, detection of fraudulent acts, and any other unlawful
          activity.
        </li>

        <li className={classes.content}>
          In addition, the Company may use the information for marketing,
          advertising, and direct mailing purposes, either by the Company or by
          third parties providing services in cooperation with it, including
          personalized advertising.
        </li>

        <li className={classes.content}>
          The Website Operator and/or the Company may also use the information
          received from the user and/or information collected about him for:
          contacting the user when needed; maintaining the Website and/or
          systems; improving information and content offered on the Website to
          users individually and/or to all or part of the Website’s users.
        </li>

        <li className={classes.content}>
          Without derogating from the above, subject to the user providing
          contact details and agreeing to receive direct mail, the Company may
          send the user, from time to time, by email, SMS, or other means of
          communication, information regarding its services as well as marketing
          and promotional material. The user may withdraw consent at any time by
          sending a request to email ______ or via the “unsubscribe” link
          included in each message.
        </li>

        <li className={classes.content}>
          The Website uses Cookies for proper and continuous operation,
          including collecting statistical data, verifying details,
          personalizing the Website, identifying suitable products, and for
          security purposes. Cookies are text files created by the user’s
          browser following instructions from the Company’s servers. Some
          cookies expire when the browser is closed; others are saved on the
          user's hard drive. Cookies may store information such as pages
          visited, time spent, entry origin, categories viewed, and more. They
          may also store browsing habits on other websites. Cookie information
          is encrypted, and the Company takes precautions to ensure only
          authorized personnel can read it. If you do not wish to accept
          cookies, you may disable them in your browser settings; however,
          disabling cookies may prevent use of some Website features.
        </li>

        <li className={classes.content}>
          <b>Disclosure of Information to Third Parties</b> – The Website
          Operator and the Company will take reasonable measures to protect
          personal information, but may disclose it in the following cases: • at
          the user’s request and/or with explicit consent; • to Company service
          providers such as suppliers and courier companies for the purpose of
          providing services, including completing user purchases; • in case of
          violation of Terms of Use or Privacy Policy; • pursuant to a judicial
          order; • in the event of disputes, claims, or legal proceedings
          between the user and the Company; • if disclosure is required to
          prevent serious harm to the Website Operator, the Company, the user,
          or third parties; • if the Website Operator or Company transfers its
          activities, rights, or obligations to a third party, provided such
          third party agrees to the terms of this Policy.
        </li>

        <li className={classes.content}>
          Nothing in the above prevents the Website Operator or the Company from
          providing non-personal information—such as aggregated statistical
          data—for research and statistical purposes.
        </li>

        <li className={classes.content}>
          The Website Operator or the Company may also use third-party providers
          to collect, store, or process information as described in this Policy,
          subject to applicable law.
        </li>

        <li className={classes.content}>
          <b>Information Security</b> – The Website Operator and the Company
          take reasonable and accepted security measures, including advanced
          technologies, to protect the confidentiality of user data. However,
          they cannot guarantee absolute protection against disruptions or
          unauthorized access.
        </li>

        <li className={classes.content}>
          The Company uses SSL encryption technology commonly used in e-commerce
          in Israel and the United States for secure online data transfer, as
          required by law.
        </li>

        <li className={classes.content}>
          The Website Operator uses advanced technological and organizational
          measures to secure the Website and information held under its control
          against accidental or intentional misuse, destruction, loss, or
          unauthorized access. Despite these efforts, incidents beyond the
          Website Operator’s control may occur, and the Operator shall not be
          liable for damage resulting from such events, including privacy
          breaches.
        </li>

        <li className={classes.content}>
          All credit card processing on the Website is encrypted and secured by
          an external payment provider using modern encryption methods that
          comply with international standards.
        </li>

        <li className={classes.content}>
          <b>Contact Regarding Privacy</b> – You, or anyone on your behalf, may
          review personal information stored about you in the Company’s database
          and request correction of inaccurate, incomplete, or outdated
          information. To exercise this right, submit a request via the “Contact
          Us” page.
        </li>

        <li className={classes.content}>
          For any question, clarification, or request regarding this Privacy
          Policy—or if you wish to delete, update, or modify your personal
          information—please contact us via [Contact Us]. All correspondence
          must include your full details, including address and email. We will
          make reasonable efforts to respond in a timely manner.
        </li>

        <li className={classes.content}>
          If the Website contains links to external websites, Israeli or
          foreign, the Company and/or Website Operator are not responsible for
          their content. The presence of a link on the Website <b>does not</b>{" "}
          constitute a recommendation to visit it, and any visit is at the
          user’s own discretion.
        </li>
      </ol>
    </div>
  );
};
